import React, { useEffect, useState } from "react";
import { apiGet, apiPost } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { useForm } from "react-hook-form";
import useToastContext from "hooks/useToastContext";
import ErrorMessage from "components/ErrorMessage";
import { useTranslation } from "react-i18next";
import OInputField from "components/reusable/OInputField";
import { preventMaxInput } from "utils/validations";
import formValidation from "../../utils/formValidation";

const CityAdd = ({ allCity, handleCategory }) => {
  const { t } = useTranslation();
  const notification = useToastContext();
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cat, setCat] = useState("");
  const [stat, setStat] = useState("");

  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {},
  });

  const onSubmit = async (data) => {
    try {
      const payload = {
        countryID: cat,
        stateID: stat,
        name: data?.name?.trim(),
      };
      const res = await apiPost(apiPath.cityAdd, payload);
      if (res?.data?.success) {
        allCity();
        handleCategory(false);
        notification.success(res?.data?.message);
      } else {
        notification.error(res?.data?.message);
      }
    } catch (err) {
      console.log("err:", err);
    }
  };

  const getCountryList = async () => {
    try {
      const res = await apiGet(apiPath.getCountryList, {});
      setCountries(res?.data?.results?.allCountries || []);
    } catch (error) {
      console.log("error:", error);
    }
  };

  const getStateList = async () => {
    try {
      const res = await apiGet(apiPath.getStateList, {});
      setStates(res?.data?.results?.allStates || []);
    } catch (error) {
      console.log("error:", error);
    }
  };

  const selectCategoryCountry = (e) => {
    if (e.target.value) {
      setCat(e.target.value);
      clearErrors("countryID");
    } else {
      setCat("");
      setError("countryID", {
        type: "validation",
        message: "Please select country.",
      });
    }
  };

  const selectCategoryState = (e) => {
    if (e.target.value) {
      setStat(e.target.value);
      clearErrors("stateID");
    } else {
      setStat("");
      setError("stateID", {
        type: "validation",
        message: "Please select state.",
      });
    }
  };

  useEffect(() => {
    getCountryList();
    getStateList();
  }, []);

  return (
    <>
      <div className="overflow-x-hidden justify-center items-center flex overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <div className="md:py-4 sm:px-2 sm:py-8 px-7">
            <div className="flex flex-col border-0 rounded-lg shadow-lg relative w-full bg-white outline-none focus:outline-none min-w-[762px]">
              {/*header*/}
              <div className="border-b flex items-center justify-between p-5 border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">{t("ADD_CITY")}</h3>
                <button
                  className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                  onClick={() => handleCategory(false)}
                  title="Close"
                >
                  <span className="text-4xl text-[#B8BBBF]" title="Close">
                    ×
                  </span>
                </button>
              </div>
              {/*body*/}
              <div className="flex-auto relative p-6 ">
                <div className="grid sm:grid-cols-2">
                  <div className="px-7 md:py-4 sm:px-2 sm:py-8">
                    <div className="group relative z-0 w-full">
                      <select
                        className="border-2 block py-4 px-3 w-full text-sm text-gray-900 bg-transparent rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                        placeholder=" "
                        type="select"
                        id="countryID"
                        value={cat}
                        {...register("countryID", {
                          required: "Please select country name.",
                        })}
                        onChange={selectCategoryCountry}
                      >
                        <option value="">{t("SELECT_COUNTRY")}</option>
                        {countries.map((item) => (
                          <option key={item?._id} value={item?._id}>
                            {item?.name}
                          </option>
                        ))}
                      </select>
                      <label
                        htmlFor="countryID"
                        className="text-[#A5A5A5] dark:text-gray-400 duration-300 peer-focus:font-normal absolute text-sm transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      >
                        {" "}
                        {t("COUNTRY")}
                        <span className="text-red-500">*</span>
                      </label>
                      <ErrorMessage message={errors?.countryID?.message} />
                    </div>
                  </div>
                  <div className="md:py-4 sm:px-2 sm:py-8 px-7">
                    <div className="group relative z-0 w-full">
                      <select
                        className="border-2 block py-4 px-3 w-full text-sm text-gray-900 bg-transparent rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                        placeholder=" "
                        type="select"
                        id="stateID"
                        value={stat}
                        {...register("stateID", {
                          required: "Please select state name.",
                        })}
                        onChange={selectCategoryState}
                      >
                        <option value="">{t("SELECT_STATE")}</option>
                        {states.map((item) => (
                          <option key={item?._id} value={item?._id}>
                            {item?.name}
                          </option>
                        ))}
                      </select>
                      <label
                        htmlFor="stateID"
                        className="text-[#A5A5A5] dark:text-gray-400 duration-300 peer-focus:font-normal absolute text-sm transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      >
                        {" "}
                        {t("STATE")}
                        <span className="text-red-500">*</span>
                      </label>
                      <ErrorMessage message={errors?.stateID?.message} />
                    </div>
                  </div>
                  <div className="md:py-4 sm:px-2 sm:py-8 px-7">
                    <OInputField
                      name="name"
                      inputLabel={
                        <>
                          {t("CITY")}
                          <span className="text-red-500">*</span>
                        </>
                      }
                      wrapperClassName="relative z-0 w-full group"
                      type="text"
                      autoFocus={true}
                      maxLength={30}
                      onInput={(e) => preventMaxInput(e, 30)}
                      register={register("name", {
                        ...formValidation["cityName"],
                        validate: (value) => {
                          const wordCount = value.trim().split(/\s+/).length;
                          return (
                            wordCount <= 4 || "City name cannot exceed 4 words."
                          );
                        },
                      })}
                      id="name"
                      errors={errors}
                      placeholder=""
                    />
                    <ErrorMessage message={errors?.name?.message} />
                  </div>
                </div>
              </div>
              <div className="justify-center p-6 border-t border-solid border-slate-200 flex items-center rounded-b">
                <button
                  className="focus:outline-none rounded mr-6 text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none ease-linear transition-all duration-150"
                  onClick={() => handleCategory(false)}
                  type="button"
                >
                  {t("O_BACK")}
                </button>
                <button
                  onClick={handleSubmit(onSubmit)}
                  className="active:bg-emerald-600 bg-LightBlue text-white font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150"
                  type="submit"
                >
                  {t("O_ADD")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="inset-0 z-40 bg-black opacity-25 fixed" />
    </>
  );
};

export default CityAdd;